import dayjs from 'dayjs';
import { useLanguage } from '../contexts/language';
import { DAYJS_VISUALIZATION_DATE_FORMAT } from '../utils/date';
import { Timeline } from './Timeline';
import { ReasonNote } from '../types/core';

const RejectionNotesTimeline = ({
  rejectionNotes,
}: {
  rejectionNotes: ReasonNote<unknown>[];
}) => {
  const { t } = useLanguage();

  return (
    <Timeline
      key="notes"
      items={rejectionNotes}
      getItemKey={({ id }) => id}
      renderItemHeader={({ type }) =>
        typeof type === 'string'
          ? t(`note-types.${type}`)
          : t('content.unknown')
      }
      renderItemContent={({ creationDate, note }) => (
        <div>
          <div className="font-medium opacity-80 text-xs mb-4">
            {dayjs(creationDate).format(DAYJS_VISUALIZATION_DATE_FORMAT)}
          </div>
          <section className="text-sm opacity-80">
            {note.split('\n').map((text, index) => (
              <p key={index} className="mb-2">
                {text}
              </p>
            ))}
          </section>
        </div>
      )}
    />
  );
};

export default RejectionNotesTimeline;
